import type { ModelLead } from '@app/api/Leads/types';

import { getLeadsRegistryLeadInfo } from './getLeadsRegistryLeadInfo';
import { getLeadsRegistryLegacyColumns } from './getLeadsRegistryLegacyColumns';

import type { LeadsRegistryLeadRow } from '../types';

export const mapModelLeadToLeadsRegistryTableRow = (
  lead: ModelLead,
  canShowContacts: boolean
): LeadsRegistryLeadRow => ({
  kind: 'lead',
  id: lead.Id,
  sourceLead: lead,
  leadInfo: getLeadsRegistryLeadInfo(lead, canShowContacts),
  legacyColumns: getLeadsRegistryLegacyColumns(lead),
});
